export enum EchargerProtocol {
  ELOADED = 'ELOADED',
  OCPP = 'OCPP'
}
